const FORM_URL = `${process.env.MIX_FORMS_URL}api/send/sani-dental-group/free-quote`

export default () => ({
  inputElements: [],
  proceduresAlert: [],
  count: [],
  name: { errorMessage: '', blurred: false },
  email: { errorMessage: '', blurred: false },
  phone: { errorMessage: '', blurred: false },
  destination: { errorMessage: '', blurred: false },
  usPrice: 0,
  savings: 0,
  percent: 0,
  formData: {
    name: '',
    email_address: '',
    phone: '',
    destination: '',
    procedures: [],
    totalPrice: 0,
    source: 'New Free Quote',
    utm: window.location.href,
    zip_code: '',
  },
  formSubmitted: false,
  formMsg: '',
  buttonText: "Send quote",
  modalText: '',

  getProcedures(groups) {
    if (groups) {
      groups.forEach((group) => {
        group.procedures.forEach(procedure => {
          this.count.push({
            group: group.id,
            id: procedure.id,
            count: 0
          });
        })
      });
    }
  },

  addProcedure(procedure) {
    let element = this.formData.procedures.find(p => p.name === procedure.name);
    if (element) {
      element.qty++
    } else {
      procedure.qty = 1
      this.formData.procedures.push(procedure)
    }
  },
  removeProcedure(procedure) {
    let element = this.formData.procedures.find(p => p.name === procedure.name);
    if (element) {
      if (element.qty > 1) {
        element.qty--;
      } else {
        const index = this.formData.procedures.indexOf(element);
        if (index !== -1) {
          this.formData.procedures.splice(index, 1);
        }
      }
    }
  },
  plus(param) {
    let result = this.count.find(procedure => procedure.id === param.id &&
      procedure.group === param.price_group_id);
    result.count++;
    this.updateStorePrices(param);
    this.addProcedure(param);
  },

  minus(param) {
    let res = this.count.find(procedure => procedure.id === param.id &&
      procedure.group === param.price_group_id);
    res.count--;
    this.updateStorePrices({
      our_price: -param.our_price,
      us_price: -param.us_price,
      savings: -(param.us_price - param.our_price),
    });
    this.removeProcedure(param)
  },

  updateStorePrices(param) {
    this.usPrice += param.us_price;
    this.formData.totalPrice += param.our_price;
    this.savings += param.us_price - param.our_price;
    this.percent = 100 - (parseInt((this.formData.totalPrice / (this.usPrice || 1)) * 100, 10) || 100) + '%'
  },

  validatePhone() {
    this.formData.phone = this.formData.phone.replace(/\D/g, '');
  },

  submitForm(event) {
    this.inputElements = [...this.$el.querySelectorAll('[data-rules]')];
    this.proceduresAlert = document.getElementById('procedures_id');

    if (this.formData.procedures.length < 1) {
      this.proceduresAlert.classList.remove('is-hidden')
    } else {
      if (!this.proceduresAlert.classList.contains("is-hidden")) {
        this.proceduresAlert.classList.add("is-hidden")
      }
    }

    const validate = (val) => val === true;
    const isValid = [];

    this.inputElements.map((input) => {
      const error = Iodine.assert(input.value, JSON.parse(input.dataset.rules));
      isValid.push(error.valid);
      if (!error.valid) {
        event.preventDefault();
        input.classList.add('is-danger');
        this[input.name].errorMessage = error.error;
      } else {
        input.classList.remove('is-danger');
        this[input.name].errorMessage = '';
      }
    });

    if (isValid.every(validate) && this.formData.procedures.length > 0) {
      this.postForm()
    }
  },

  postForm() {
    this.buttonText = 'Submitting...';
    if (!this.formData.zip_code) {
      axios
        .post(FORM_URL, this.formData)
        .then((res) => {
          this.formMsg = 'Your message has been sent.';
          this.formSubmitted = true;
          this.modalText = 'Our team of patient coordinators will contact you very soon. If you do not receive your email within 24-48 hours, please contact us at (928)-257-1307.'
        })
        .then(() => {
          this.formData.name = '';
          this.formData.email_address = '';
          this.formData.phone = '';
          this.formData.destination = '';
          this.formData.source = '';
          this.formData.totalPrice = 0;
          this.buttonText = 'Send quote';
          this.procedures = [];
          this.usPrice = 0;
          this.savings = 0;
          this.percent = 0;
          this.count.forEach((procedure) => procedure.count = 0);
        })
        .catch((err) => {
          console.error(err.response.data);
          this.formSubmitted = true;
          this.formMsg = 'Something went wrong.';
          this.modalText = "Wops, something went wrong."
        })
    }
  },
})
